import { FC } from "react";
import { CourseCard } from "./components/CourseCard";
import { CourseData, PricingOption } from "./types";
import { useWebsiteCatalog } from "entities/course-catalog";
import { admissionModel } from "widgets/admission";
import { popoutModel } from "shared/ui/popout-root";
import styles from './styles.module.scss';

export const Courses: FC = () => {
    const { status, catalog, error, retry } = useWebsiteCatalog();

    const handleCourseSelect = (course: CourseData, pricing?: PricingOption) => {
        admissionModel.events.setPricingSelect(null);
        admissionModel.events.setTrainingSelect(null);
        admissionModel.events.setCourseSelect({
            name: course.title,
            courseData: course,
            pricingOption: pricing || null
        });

        if (!pricing) return;

        admissionModel.events.setPricingSelect(pricing);
        const trainingId = `${pricing.format}_${pricing.type === 'individual' ? '1' : pricing.type === 'closed_group' ? '2' : '3'}` as any;
        admissionModel.events.setTrainingSelect({ id: trainingId });
        popoutModel.events.setPopout('admission');
    };

    return (
        <div className={styles.courses} id="courses">
            <div className={styles.__in}>
                <div className={styles.title}>
                    Учим IT-профессиям на практике
                </div>

                <div className={styles.sub_title}>
                    Эксперты из IT-индустрии разрабатывают курсы и поддерживают вас на всем пути
                </div>

                <div className={styles.list}>
                    {status === 'loading' ? <div role="status">Загружаем цены…</div> : null}
                    {status === 'error' ? (
                        <div role="alert">
                            {error}
                            <button type="button" onClick={retry}>Повторить</button>
                        </div>
                    ) : null}
                    {catalog?.courses.map((course) => (
                        <CourseCard
                            key={course.id}
                            course={course}
                            pricingAvailable={status === 'ready'}
                            pricingMessage={status === 'loading' ? 'Загружаем цены…' : 'Не удалось загрузить цены'}
                            onSelectCourse={handleCourseSelect}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};
